import { Injectable, inject } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ALERT_HISTORY_REQUEST } from "../../features/alerts/services/alert-history-session.service";
// eslint-disable
@Injectable()
export class TenantIdInterceptor implements HttpInterceptor {
  readonly route = inject(ActivatedRoute);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Alert History requests are not tenant-scoped by header (TWX-536)
    if (req.context.get(ALERT_HISTORY_REQUEST)) {
      return next.handle(req);
    }

    const tenantIdParamFromCurrentUrl =
      this.route.snapshot.queryParams["tenantId"];

    const tenantId =
      tenantIdParamFromCurrentUrl ?? environment.fallbackTenantId; // TODO: Get tenant ID from subdomain
    const modifiedReq = req.clone({
      setHeaders: { "Tenant-Id": tenantId },
    });
    return next.handle(modifiedReq);
  }
}
